module.exports = __webpack_public_path__ + "static/media/acl.ef9083bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pictures/acl.jpg
// module id = 315
// module chunks = 0